import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { FaqsComponent } from './faqs/faqs.component';
import { HelpComponent} from './help/help.component';
import { AuthComponent } from './auth/auth.component';
import { AppstoreComponent} from './appstore/appstore.component';
import { ContactComponent} from './contact/contact.component';
import { CreditComponent} from './credit/credit.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { RegisterComponent } from './register/register.component';
import { SchedaintenseMainComponent } from './shared/schedaintense-view';
import { EsperienzaMainComponent} from './shared/esperienza-view';
import { RoutGuardService } from './core/services/rout-guard.service';
import { Error404Component} from './error404/error404.component';
import { SavedExperienceComponent } from './downloaded/saved-experience/saved-experience.component';
import { SavedOstComponent} from './downloaded/saved-ost/saved-ost.component';
import { DownloadsComponent } from './downloaded/downloads/downloads.component';
import { MapsComponent } from './maps/maps.component'
import { ProfileComponent} from './profile/profile.component';
import { PrivacyComponent} from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component'; 
import { EsperienzaAdminSearchComponent} from './shared/esperienza-admin';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SettingsComponent } from './settings/settings.component';
import { UserComponent } from './user/user.component';
import { RoleEnum} from './core/models/role.enum';
import { OstViewComponent } from './shared/ost-view/ost-view.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ItemViewComponent } from './shared/item-view/item-view.component';
import { ActivateUserComponent } from './activateuser/activateuser.component';
import { SsoreturnComponent } from './ssoreturn/ssoreturn.component';
import { PathLocationStrategy, LocationStrategy, HashLocationStrategy } from '@angular/common';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full',},
      { path: 'appstore', component: AppstoreComponent},
      { path: 'contact', component: ContactComponent},
      { path: 'credit', component: CreditComponent},
      { path: 'disclaimer', component: DisclaimerComponent},
      { path: 'faqs', component: FaqsComponent },
      { path: 'help', component: HelpComponent },
      { path: 'login', component: AuthComponent},
      { path: 'search', component: SearchComponent, runGuardsAndResolvers: 'always'},
      { path: 'privacy', component: PrivacyComponent},
      { path: 'terms', component: TermsComponent},
      { path: 'register', component: RegisterComponent},
      { path: 'scheda/:id', component: SchedaintenseMainComponent},
      { path: 'notifications', component: NotificationsComponent, canActivate:[RoutGuardService], data: { roles: [RoleEnum.supervisor]}},
      { path: 'esperienza/admin', component: EsperienzaAdminSearchComponent, canActivate:[RoutGuardService], data: { roles: [RoleEnum.supervisor]}},
      { path: 'esperienza/admin/:id', component: EsperienzaMainComponent, canActivate:[RoutGuardService], data: { roles: [RoleEnum.supervisor]}},
      { path: 'esperienza/:id', component: EsperienzaMainComponent},
      { path: 'downloaded/experience', component: SavedExperienceComponent,canActivate: [RoutGuardService]},
      { path: 'downloaded/ost/:id', component: SavedOstComponent,canActivate: [RoutGuardService]},
      { path: 'downloaded', component: DownloadsComponent, canActivate: [RoutGuardService]},
      { path: 'maps', component: MapsComponent},
      { path: 'esperienza/edit/:id', component: EsperienzaMainComponent, canActivate: [RoutGuardService]},
      { path: 'esperienza/share/:id', component: EsperienzaMainComponent, canActivate: [RoutGuardService]},
      { path: 'bio/:username', component: ProfileComponent, canActivate:[RoutGuardService]},
      { path: 'settings/:username', component: SettingsComponent, canActivate:[RoutGuardService]},
      { path: 'user', component: UserComponent,},
      { path: 'resetpassword', component: ResetpasswordComponent},
      { path: 'ost/:id', component: OstViewComponent},
      { path: 'item/:id', component: ItemViewComponent},
      { path: 'activateuser', component: ActivateUserComponent},
      { path: 'ssoreturn', component: SsoreturnComponent},
      { path: '**', component: Error404Component }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { 
    preloadingStrategy: PreloadAllModules,
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule],
  providers: [
    PathLocationStrategy, 
    { provide: LocationStrategy, useClass: HashLocationStrategy},
    RoutGuardService
  ]
})
export class AppRoutingModule {}